import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import Axios from '../config/axios';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NumberFormat from 'react-number-format';

class Contact extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formFields: {
                contactReason: "",
                contactPriority: "",
                contactName: "",
                contactCompany: "",
                contactEmail: "",
                contactPhone: "",
                contactContent: ""
            },
            loading: false,
            supportRequest: false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.notifyFail = this.notifyFail.bind(this);
        this.notifySuccess = this.notifySuccess.bind(this);
    }

    componentDidMount() {
        if (this.props && this.props.supportRequest) {
            this.setState({
                supportRequest: true
            });
        }

            window.scrollTo(0, 0);
    }

    notifySuccess = () => toast.success('Thank you for reaching out. Somebody will be in touch with you shortly.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true
    });

    notifyFail = (message) => toast.error(message, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true
    });

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ formFields: { ...this.state.formFields, [name]: value } });
    }

    handleSubmit() {
        let postdata = {};

        //switch (this.state.formFields.contactReason) {
        //    case 'reason-1':
        //        postdata.contactReason = 'System Down';
        //        break;
        //    case 'reason-2':
        //        postdata.contactReason = 'Reason 1';
        //        break;
        //    case 'reason-3':
        //        postdata.contactReason = 'Reason 2';
        //        break;
        //    case 'reason-4':
        //        postdata.contactReason = 'Reason 4';
        //        break;
        //    default:
        //        postdata.contactReason = 'No Reason';
        //        break;
        //}
        postdata.supportRequest = this.state.supportRequest;
        postdata.contactPriority = this.state.formFields.contactPriority;
        postdata.contactName = this.state.formFields.contactName;
        postdata.contactCompany = this.state.formFields.contactCompany;
        postdata.contactEmail = this.state.formFields.contactEmail;
        postdata.contactContent = this.state.formFields.contactContent;
        postdata.contactPhone = this.state.formFields.contactPhone;
        postdata.contactReason = this.state.formFields.contactReason

        if (postdata.contactName === "" ||
            postdata.contactEmail === "" ||
            postdata.contactPhone === "" ||
            postdata.contactContent === "") {
            this.notifyFail('Please make sure all fields are filled out.');
            //console.log("not all filled out")
        } else {
            


            Axios.post(`/api/GetInTouch`, postdata
            ).then(response => {
                if (response.data === true) {
                    this.notifySuccess();
                    //console.log("Success");
                    let ffCopy = this.state.formFields;
                    ffCopy.contactContent = "";
                    ffCopy.contactEmail = "";
                    ffCopy.contactName = "";
                    ffCopy.contactCompany = "";
                    ffCopy.contactPhone = "";
                    ffCopy.contactPriority = "";
                    ffCopy.contactReason = "";
                    this.setState({
                        formFields: ffCopy
                    });
                } else {
                    //console.log("Failed")
                    this.notifyFail();
                    
                }
            }).catch(error => {
                this.notifyFail('Something went wrong. Please reach out directly at support@customapps.net.');
                //console.log("Failed");
                
                console.log(error);
            });
        }


    }


    render() {

        const supportRequest = this.state.supportRequest;

        return (
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <Banner
                    headText="Contact Us"
                    subHeadText="We look forward to helping you with your technology needs"
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="interior-1.jpg"
                />
                <div className="main-container">
                    <div className="container">
                        <div className="row">

                            <div className="col-sm-12 well">
                                
                                    {supportRequest ? 
                                    <div>
                                        <div>
                                            <h3>We Are Here For You!</h3>
                                            Please let us know what we can do for you and we will get back to you just as soon as possible.<br /><br />
                                        </div>

                                        <div className="form-group col-md-6 col-sm-12">
                                            <dd>

                                                <select className="form-control" id="example-select" name="contactReason" value={this.state.formFields.contactReason} onChange={this.handleInputChange}>
                                                    <option value="" disabled selected hidden>Contact Reason</option>
                                                    <option value="System Is Down">System Is Down</option>
                                                    <option value="New Project">New Project</option>
                                                    <option value="Application Enhancement">Application Enhancement</option>
                                                    <option value="Application Bug Fix">Application Bug Fix</option>
                                                    <option value="General Inquiry">General Inquiry</option>
                                                </select>
                                            </dd>
                                        </div>

                                        <div className="form-group col-md-6 col-sm-12">
                                            <dd>

                                                <select className="form-control" id="example-select" name="contactPriority" value={this.state.formFields.contactPriority} onChange={this.handleInputChange}>
                                                    <option value="" disabled selected hidden className="grey-color">Contact Priority</option>
                                                    <option value="Low">Low</option>
                                                    <option value="Medium">Medium</option>
                                                    <option value="High">High</option>
                                                </select>
                                            </dd>
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <h3>We Are Here For You!</h3>
                                        Please let us know what we can do for you and we will get back to you just as soon as possible.<br /><br />
                                    </div>
                                    }
                                    

                                        <div className="form-group col-md-6 col-sm-12">
                                            <input type="text" className="form-control" id="" name="contactName" placeholder="Your Name" value={this.state.formFields.contactName} onChange={this.handleInputChange}/>
                                        </div>
                                        <div className="form-group col-md-6 col-sm-12">
                                            <input type="text" className="form-control" id="" name="contactCompany" placeholder="Company Name" value={this.state.formFields.contactCompany} onChange={this.handleInputChange} />
                                        </div>
                                        <div className="input-group-custom form-group col-md-6 col-sm-12">

                                            <span className="input-group-addon glyphicon glyphicon-envelope" id=""></span> <input type="email" className="form-control" id="" name="contactEmail" placeholder="Your Email" value={this.state.formFields.contactEmail} onChange={this.handleInputChange} />
                                        </div>

                                        <div className="input-group-custom form-group col-md-6 col-sm-12">

                                        <span className="input-group-addon glyphicon glyphicon-phone-alt" id=""></span>
                                        <NumberFormat className="form-control" name="contactPhone" value={this.state.formFields.contactPhone} onChange={this.handleInputChange} format="(###) ###-####" placeholder="Your Phone Number" mask="_" />
                                        </div>
                                        <div className="form-group message col-sm-12">
                                            <textarea className="form-control" rows="6" id="message" name="contactContent" placeholder="Type your comments or questions here..." value={this.state.formFields.contactContent} onChange={this.handleInputChange}></textarea>
                                        </div>


                                        <button type="submit" className="btn btn-warning colorBlack" onClick={this.handleSubmit}>Submit</button>
                                    
                                
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Contact);


// WEBPACK FOOTER //
// ./src/components/Contact.js